export const ACTION_TYPE = "parentCategorytype";
